import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/other-templates')({
    component: OtherTemplatesRedirect,
});

// Fill-shift and completion templates now live in the Scheduling page's
// outreach templates (the "Fill shift" and "Others" tabs).
function OtherTemplatesRedirect() {
    return <Navigate to="/settings/outreach-automation" replace={true} />;
}
